import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@shared/hooks/useAuth';
import { appRoutes, publicRoutes } from '@config/routes';
import type { RoleType } from '@config/roles';

interface RequireRoleProps {
  children: ReactNode;
  allowedRoles: RoleType[];
}

export function RequireRole({ children, allowedRoles }: RequireRoleProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to={publicRoutes.login} replace />;
  }

  if (!user.isSuperAdmin && !allowedRoles.includes(user.role as RoleType)) {
    return <Navigate to={appRoutes.dashboard} replace />;
  }

  return <>{children}</>;
}

